// extracted by mini-css-extract-plugin
module.exports = {"svg":"CircularProgress_svg__2tKQx","rotate":"CircularProgress_rotate__3wS5Z","circle":"CircularProgress_circle__3EyCm","dash":"CircularProgress_dash__3BxOg"};